<template>
  <div class="regular-faq">
    <h3 class="regular-faq_title">定期コースのよくあるご質問</h3>

    <ul class="faq-list">
      <li v-for="(faq, index) in faqs" :key="index">
        <NuxtLink :to="`/regular#${regularFaqAnchorId(index)}`" class="faq-item">
          <span class="faq-item_q">Q</span>
          <span class="faq-item_text">{{ faq }}</span>
          <span class="faq-item_arrow"></span>
        </NuxtLink>
      </li>
    </ul>

    <div class="btn-round-area">
      <NuxtLink to="/regular" class="btn-round">
        定期コースの質問をすべて見る<span class="btn-round_arrow"></span>
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * 支給デザインの `regular-faq`（定期コースのよくあるご質問）。サポート導線4コンテンツの1つ。
 *
 * **`OrganismsSupportRegular` の `section.sec_footer-regular` の中で呼ぶ。**
 * `.regular-faq` 自体の CSS は祖先に依存しないが、`.sec_footer-regular` が `max-width: 940px` を
 * 持っているため、section の外に出すと横幅が変わる。
 *
 * 設問は `RegularFaqConst` から先頭5件を引く。**支給98本のこのブロックの5件と完全に一致する**
 * （2026-08-13 に `/regular` の Q&A を支給の10件へ差し替えた結果）。
 *
 * **飛び先は押した設問のアンカー**（`/regular#regular-faq-N`）。支給は5件とも `href="#"` の
 * プレースホルダで（決定#33）、ハッシュ無しにすると**どれを押しても `/regular` の先頭**に着地する。
 * ID は `regularFaqAnchorId` が `REGULAR_FAQ_LIST` の並びから導出する — ここも `/regular` 本体も
 * 同じ const を同じ順で読むので添字が揃う（決定#5）。
 */
import { REGULAR_FAQ_LIST, regularFaqAnchorId } from '@/consts/RegularFaqConst';

const FAQ_DISPLAY_COUNT = 5;

const faqs = computed<string[]>(() =>
  REGULAR_FAQ_LIST.slice(0, FAQ_DISPLAY_COUNT).map((faq) => faq.question)
);
</script>
